module.exports = "../../app/cells/pages/guides/cta_matter_list_cell.rb";